import React from 'react';
import styles from './Dashboard.module.css';

const LoadingOverlay = ({ loading }) => {
    if (!loading) return null;

    return (
        <div className={styles.loadingOverlay}>
            <div className={styles.spinner}></div>
        </div>
    );
};

export default LoadingOverlay;